import React, { Fragment } from "react";
import {
  List,
  Link,
  Datagrid,
  Filter,
  EditButton, Pagination,
  useRecordContext,
  Button,
  TextInput,
  TextField,
  ShowButton,
  TopToolbar,
  DateInput,
  useListContext,
  FunctionField,
  RichTextField


} from "react-admin";
import { makeStyles } from '@material-ui/core';
import BulkRejectButton from './Action/Bulk.Reject.Button';
import BulkActiveButton from './Action/Bulk.Active.Button';
import DownloadIcon from '@material-ui/icons/GetApp';
import { RefundDocumentStatus, IncomePlanSelectInput, WithdrawPaymentInfonewSelectInput } from '../../UI/Input/SelectInput'
import { stringify } from 'query-string';
const ListFilter = (props) => {
  const {

    setFilters,
    hideFilter
  } = useListContext();
  return (<Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  
  </Filter>)
};



const ProfileidFiled = (props) => {
  const record = useRecordContext();
  return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
  )
}



const BulkActionButtons = ({ gift_id, ...props }) => {

  return (<Fragment>

    <BulkRejectButton label="Bulck Reject"  {...props} />
    <BulkActiveButton label="Bulck Approve"  {...props} />
  </Fragment>)
}

const ListActions = (props) => {
  const record = useListContext();
  const filva = record.filterValues ? stringify(record.filterValues) : '';
  return (<TopToolbar>
    <Button href={`//sboportal.org.in/admin/api/v1/refundpaymentproof/export?${filva}`} label="Export Data" ><DownloadIcon /></Button>
  </TopToolbar>);
}

const PostPagination = ({ record, ...props }) => {
  return (<Pagination rowsPerPageOptions={[10, 20, 30, 200, 500,]} {...props} />)
}

const SuspendedBlockedUserBankList = ({ ...props }) => {
  const classes = useStyles()
  const [userstatusCreate, setUserStatusCreate] = React.useState(null)
  const handleStatusSelect = (record) => {
    setUserStatusCreate({ record: record })
  }

  return (
    <Fragment>
      <List
        {...props}
        pagination={<PostPagination />}
        title="Refund user proofs - july-26"


        bulkActionButtons={<BulkActionButtons />}
       
        filters={<ListFilter />}
      >
        <Datagrid >
         
          <TextField source="id" />
                            <TextField label="Account Number" source="account_no" sortable={false} />
                            <TextField label="Account Holder Name" source="account_holder_name" sortable={false} />
                            <TextField label="IFSC" source="ifsc" sortable={false} />
                            <TextField label="Bank Name" source="bank_name" sortable={false} />
                            <RichTextField label="Branch" source="branch" sortable={false} />
        </Datagrid>
      </List>

    </Fragment>
  );
};
const useStyles = makeStyles({
  numberCell: { width: 60 },
  actionCell: { width: 100 },
  layoutCell: { width: 120 }
})
export default SuspendedBlockedUserBankList;
